export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  source: string;
  tags: string[];
  content: string[];
}

export const newsTags: string[] = ["新闻", "活动", "预告", "评测", "访谈"];

export const newsList: NewsItem[] = [
  {
    id: "starsea-season2",
    title: "《星海航路》第二季定档十月 全新预告正式公开",
    summary:
      "备受期待的科幻冒险动画《星海航路》第二季宣布将于十月开播，官方同步放出了全新预告片与主视觉海报，揭开星际航路的新篇章。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20young%20pilot%20standing%20before%20a%20glowing%20starship%20under%20a%20deep%20blue%20starfield%2C%20vibrant%20orange%20highlights%2C%20cel%20shaded%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20clean%20detailed%20background&width=1200&height=800&seq=news-cover-starsea&orientation=landscape",
    date: "2026-10-08",
    source: "91动漫编辑部",
    tags: ["预告", "新闻"],
    content: [
      "备受期待的科幻冒险动画《星海航路》正式宣布第二季将于十月开播。官方在最新发布会上公布了完整的制作阵容，并同步放出了时长约两分钟的全新预告片。",
      "预告片中，主角一行人穿越陌生星域，面对全新的危机与选择。画面延续了系列一贯的高水准作画，星云的色彩与舰船的金属质感形成了鲜明对比，被不少观众称为“年度最强视觉”。",
      "导演在采访中表示，第二季将把故事重心从“启程”转向“抉择”，角色的成长与羁绊会成为贯穿全季的主线。制作组透露本季将新增三位重要角色。",
      "《星海航路》第二季将于十月起每周更新，具体播出时间以官方后续公告为准。我们将持续跟进相关资讯。",
    ],
  },
  {
    id: "starryfest-2026",
    title: "年度动画盛典「星空祭 2026」开幕 超 30 部新作公布",
    summary:
      "一年一度的动画盛典「星空祭」正式开幕，超过三十部新作在开幕式上公布，涵盖冒险、恋爱、科幻等多个类型，让动漫爱好者大呼过瘾。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20grand%20festival%20stage%20with%20colorful%20lanterns%20and%20confetti%2C%20crowd%20of%20cheering%20fans%20silhouettes%2C%20warm%20orange%20and%20teal%20lighting%2C%20cel%20shaded%20anime%20art%20style%2C%20festive%20cinematic%20composition&width=1200&height=800&seq=news-cover-starryfest&orientation=landscape",
    date: "2026-10-05",
    source: "动漫前沿",
    tags: ["活动", "新闻"],
    content: [
      "一年一度的动画盛典「星空祭 2026」在今日正式开幕。作为动漫行业最具影响力的年度活动之一，本届盛典共计公布了三十余部新作企划。",
      "开幕式上，多部备受关注的作品公开了首支预告，其中最受瞩目的是几部改编自人气漫画的全新动画企划。类型上覆盖冒险、恋爱、科幻、治愈等多个方向。",
      "除新作公布外，现场还设置了原画展览、声优见面会与主题周边市集，吸引了大量动漫爱好者参与。主办方表示，本届盛典将持续五天。",
      "「星空祭」自创办以来，已成为众多优质作品的首次亮相舞台。91动漫将为大家整理本届盛典的重点看点。",
    ],
  },
  {
    id: "southwind-movie",
    title: "《南风物语》剧场版票房突破 20 亿 官方公开致谢海报",
    summary:
      "治愈系动画《南风物语》剧场版上映两周票房突破 20 亿，官方特别公开致谢海报与幕后制作特辑，向支持作品的观众表达感谢。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20warm%20seaside%20town%20at%20sunset%2C%20girl%20in%20summer%20dress%20walking%20along%20a%20train%20tracks%20by%20the%20sea%2C%20soft%20golden%20and%20mint%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20nostalgic%20cinematic%20wide%20shot&width=1200&height=800&seq=news-cover-southwind&orientation=landscape",
    date: "2026-10-02",
    source: "91动漫编辑部",
    tags: ["新闻"],
    content: [
      "治愈系动画《南风物语》剧场版上映两周，累计票房正式突破 20 亿。官方特别公开了一张致谢海报，画面中主角们站在海边，向观众挥手致意。",
      "作为系列的全新剧场版，本作延续了温柔细腻的叙事风格，以夏日的小镇为舞台，讲述了一段关于告别与重逢的故事。影片上映后获得了观众的高度评价。",
      "为回馈粉丝，官方还公开了一段幕后制作特辑，展示了美术团队为还原海街街景所做的实地取材工作，以及分镜设计的创作过程。",
      "目前《南风物语》剧场版仍在热映中，感兴趣的朋友记得留意排片信息。",
    ],
  },
  {
    id: "sword-traveler-anime",
    title: "人气漫画《剑与旅人》宣布动画化 主视觉图正式解禁",
    summary:
      "在连载五年后，人气奇幻漫画《剑与旅人》正式宣布动画化，官方同步解禁主视觉图与制作阵容，引发读者热烈讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20lone%20swordsman%20in%20a%20flowing%20cloak%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20kingdom%2C%20dramatic%20orange%20sky%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20cinematic%20composition%2C%20detailed%20background&width=1200&height=800&seq=news-cover-sword&orientation=landscape",
    date: "2026-09-28",
    source: "动漫前沿",
    tags: ["预告", "新闻"],
    content: [
      "连载五年的奇幻漫画《剑与旅人》正式宣布动画化。官方公布的主视觉图中，身披斗篷的旅人立于悬崖之上，眺望远方的王国，气势十足。",
      "据制作组透露，动画将忠实还原原作的世界观与关键剧情，并加入部分原创的补充场景，以让动画叙事更加完整。主要角色的声优阵容将于近期公开。",
      "原作以其扎实的世界观构建和细腻的人物刻画收获了稳定的人气，单行本累计发行量已突破可观数字。动画化消息公布后，相关话题迅速登上热搜。",
      "《剑与旅人》动画预计于明年与观众见面，91动漫将持续关注后续情报。",
    ],
  },
  {
    id: "moonlight-cafe-cast",
    title: "《月下咖啡厅》追加声优阵容公开 新角色登场",
    summary:
      "日常恋爱动画《月下咖啡厅》公开了追加声优阵容，三位新角色将在中段剧情中登场，官方同步曝光了角色设定图。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cozy%20cafe%20interior%20at%20night%20with%20warm%20lamps%2C%20barista%20girl%20smiling%20behind%20the%20counter%2C%20moonlight%20through%20the%20window%2C%20warm%20amber%20and%20teal%20accents%2C%20cel%20shaded%20anime%20art%20style%2C%20detailed%20background&width=1200&height=800&seq=news-cover-mooncafe&orientation=landscape",
    date: "2026-09-24",
    source: "91动漫编辑部",
    tags: ["新闻"],
    content: [
      "日常恋爱动画《月下咖啡厅》公开了追加声优阵容，三位新角色将在剧情中段陆续登场，为原本平静的咖啡厅带来新的故事线。",
      "官方同步曝光了三位新角色的设定图与简介，角色设计延续了作品一贯的柔和色调。声优们在采访中分享了初次接触角色时的感受。",
      "本作以一间只在夜晚营业的咖啡厅为舞台，通过一位位客人的故事，串联起主角们的成长与情感。舒缓的节奏与细腻的情感表达是其最大特色。",
      "《月下咖啡厅》目前正在更新中，喜欢治愈日常题材的观众不妨一试。",
    ],
  },
  {
    id: "mountain-river-score",
    title: "国产动画《山河引》口碑逆袭 评分持续攀升",
    summary:
      "国产古风奇幻动画《山河引》凭借扎实的剧情与精美的画面实现口碑逆袭，上线后评分持续攀升，成为近期讨论度最高的作品之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20ancient%20Chinese%20mountain%20landscape%20with%20misty%20peaks%20and%20a%20floating%20pavilion%2C%20ink%20wash%20style%20blended%20with%20anime%20art%2C%20teal%20green%20and%20warm%20gold%20accents%2C%20cinematic%20wide%20composition&width=1200&height=800&seq=news-cover-shanhe&orientation=landscape",
    date: "2026-09-20",
    source: "国漫观察",
    tags: ["新闻", "评测"],
    content: [
      "国产古风奇幻动画《山河引》在开播后迎来口碑逆袭。初期由于宣发低调，作品关注度有限，但随着剧情的推进，越来越多的观众被其扎实的叙事所吸引。",
      "本作以架空的山河世界为舞台，讲述主人公在乱世中追寻真相的旅程。美术方面融合了水墨与赛璐璐风格，形成了独特的视觉语言。",
      "许多观众在评论中提到，作品对人物动机的刻画克制而真实，配乐与画面的配合也相当出色。评分在近两周内持续攀升。",
      "《山河引》目前正在更新中，被不少观众称为“年度最值得一看的国漫之一”。",
    ],
  },
  {
    id: "mecha-city-featurette",
    title: "《机械都市 2099》公开制作特辑 揭秘世界观设定",
    summary:
      "机甲科幻动画《机械都市 2099》公开制作特辑，主创团队分享了世界观设定与机甲设计的幕后思路，展现作品的硬核一面。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20giant%20mecha%20robot%20standing%20in%20a%20futuristic%20neon%20city%20at%20night%2C%20glowing%20orange%20eyes%20and%20teal%20neon%20signs%2C%20cel%20shaded%20mecha%20anime%20art%20style%2C%20dramatic%20low%20angle%2C%20detailed%20background&width=1200&height=800&seq=news-cover-mecha&orientation=landscape",
    date: "2026-09-15",
    source: "动漫前沿",
    tags: ["预告", "访谈"],
    content: [
      "机甲科幻动画《机械都市 2099》公开了一段幕后制作特辑。主创团队在特辑中分享了作品世界观设定的由来，以及机甲设计的创作思路。",
      "据主创介绍，作品中的城市设定参考了多座真实都市的空间结构，再通过夸张化处理营造出未来感。机甲的设计则强调“机械的重量感与真实感”。",
      "制作组还展示了部分分镜与线稿，让观众得以一窥动画从概念到成片的完整流程。特辑播出后获得了大量好评。",
      "《机械都市 2099》以其独特的美术风格与扎实的设定，成为近期科幻动画爱好者热议的对象。",
    ],
  },
  {
    id: "tone-festival-tour",
    title: "动画音乐祭「音灵之夜」巡演启动 首批城市公布",
    summary:
      "人气动画音乐祭「音灵之夜」正式启动全国巡演，首批公布的巡演城市涵盖多个地区，届时将有多位动画歌手与乐队登台献唱。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20concert%20hall%20stage%20lit%20by%20warm%20orange%20spotlights%20with%20silhouettes%20of%20a%20band%20performing%2C%20teal%20haze%20and%20glowing%20particles%2C%20cel%20shaded%20anime%20art%20style%2C%20energetic%20wide%20composition&width=1200&height=800&seq=news-cover-tonefest&orientation=landscape",
    date: "2026-09-10",
    source: "动漫前沿",
    tags: ["活动"],
    content: [
      "人气动画音乐祭「音灵之夜」正式宣布启动全国巡演。首批公布的巡演城市覆盖多个地区，后续还将陆续增加场次。",
      "本次巡演将邀请多位知名动画歌手与乐队登台，曲目涵盖近年来的热门动画主题曲，以及部分经典作品的怀旧金曲。",
      "主办方表示，舞台将结合光影与影像投影，力求为观众带来沉浸式的现场体验。门票将于近期开售。",
      "对于喜爱动画音乐的观众来说，「音灵之夜」无疑是一场不容错过的现场演出。",
    ],
  },
  {
    id: "summer-echo-finale",
    title: "《夏日回响》完结篇播出 制作组公开幕后花絮",
    summary:
      "青春治愈动画《夏日回响》迎来最终话，制作组公开了一段幕后花絮，回顾了作品从企划到完结的创作历程，引发观众不舍。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20teenagers%20watching%20fireworks%20over%20a%20summer%20river%20from%20a%20bridge%2C%20warm%20golden%20and%20soft%20violet%20night%20sky%2C%20cel%20shaded%20anime%20art%20style%2C%20nostalgic%20emotional%20composition&width=1200&height=800&seq=news-cover-summerecho&orientation=landscape",
    date: "2026-09-05",
    source: "91动漫编辑部",
    tags: ["新闻"],
    content: [
      "青春治愈动画《夏日回响》迎来最终话播出，作品以一场夏日烟火与一次郑重的告别收尾，让不少观众在弹幕中表达了不舍。",
      "制作组同步公开了一段幕后花絮，回顾了作品从最初的企划构思到最终成片的完整历程。导演在花絮中分享了对结局的理解。",
      "本作以一座临海小城为舞台，讲述了几位少年少女在一个夏天里的相遇与成长。舒缓的节奏与真挚的情感是其打动观众的关键。",
      "尽管作品已经完结，但它带给观众的夏日记忆仍在延续。91动漫也将继续为大家带来更多优质作品的资讯。",
    ],
  },
];